module.exports = "{{::$ctrl.data.descripcion.substr(0, 1)}}\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/nominas/sumario/components/lista/item/estatus/template.html
// module id = 1651
// module chunks = 0